import { render, staticRenderFns } from "./ProvidentFundPolicyView.vue?vue&type=template&id=238d9070&"
import script from "./ProvidentFundPolicyView.vue?vue&type=script&lang=js&"
export * from "./ProvidentFundPolicyView.vue?vue&type=script&lang=js&"
import style0 from "./ProvidentFundPolicyView.vue?vue&type=style&index=0&id=238d9070&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports